import React, { useEffect, useState } from "react";
import Tree from "react-d3-tree";
import { useNavigate } from "react-router-dom";
import RoleNode from "./Assets/RoleNode";

export default function RoleTree() {
  const [treeData, setTreeData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchTree();
  }, []);
  const fetchTree = async () => {
    setLoading(true);
    const token = localStorage.getItem("authToken");
    if (!token) {
      console.warn("No auth token found");
      navigate("/login");
    }
    

    try {
      const response = await fetch("https://backend.sanchalansetu.com/api/v1/get-tree-list", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) throw new Error("Failed to fetch tasks");

      const result = await response.json();
      setTreeData(result);
       setLoading(false);
      /* setDepartmentDetails(result.departmentWiseTaskCalculation || []); */
    } catch (err) {
      console.error("Error fetching tasks:", err);
    }
    
  };

  return (
    <div className="Task-Details-Container">
        <div className="p-2 bg-gray-100 min-h-screen">
            <h2 className="text-2xl font-bold mb-6 text-center">
                Organization Tree
            </h2>
            <div className="flex flex-wrap  overflow-x-auto whitespace-nowrap">
                {treeData.map((root) => (
                <RoleNode key={root.id} node={root} />
                ))}
            </div>
    </div>
        
    </div>
  );
}
